import axios from "axios";

const GUARDIAO_BASE_URL = "https://api.guardiao.ufv.br";

class ServicoGuardiao {
    buscarUsuarios(busca) {
        return axios
            .get(`${GUARDIAO_BASE_URL}/rest/v1/usuarios`, {
                params: {
                    primeiro: 1,
                    maximo: 10,
                    ordenadoPor: "nome",
                    direcaoOrdenacao: "asc",
                    busca,
                },
            })
            .then((response) => response.data.itens);
    }

    buscarPessoaPorMatricula(matricula) {
        return axios
            .get(`${GUARDIAO_BASE_URL}/rest/v1/pessoas/busque-por-usuario`, {
                params: { matricula },
            })
            .then((response) => response.data);
    }

    buscarPessoaPorCpf(cpf) {
        return axios
            .get(`${GUARDIAO_BASE_URL}/rest/v1/pessoas/busque-por-cpf`, {
                params: { cpf },
            })
            .then((response) => response.data);
    }

    hidratarUsuarios(usuariosCpf) {
        return Promise.all(
            usuariosCpf.map(async (usuario) => {
                try {
                    const pessoa = await this.buscarPessoaPorCpf(usuario.cpf);
                    const [primeiroUsuario] = pessoa.usuarios;
                    return {
                        cpf: pessoa.cpf,
                        matricula: primeiroUsuario && primeiroUsuario.matricula,
                        nome: pessoa.nome.trim(),
                    };
                } catch (erro) {
                    console.error("Erro ao buscar usuário pelo CPF:", erro);
                    return usuario;
                }
            }),
        );
    }
}

export default ServicoGuardiao;
